import React from 'react';

import { useSelector } from 'react-redux';
import {
	HoverCard,
	HoverCardContent,
	HoverCardTrigger,
} from '@/components/ui/hover-card';
import { Bug } from 'lucide-react';

export function DevAuthBubble() {
	const auth = useSelector((state: any) => state.auth);

	if (process.env.NODE_ENV !== 'development') return null;

	return (
		// Desktop: small enough to sit in the page gutter, clear of grid pagination.
		// Phones: above the tab bar, and out of the way on pushed screens (composers).
		<div className="fixed bottom-4 right-4 z-50 md:bottom-1 md:right-1 max-md:bottom-[calc(var(--mobile-tabbar-height)+0.75rem)] max-md:[:root[data-tabbar-hidden]_&]:hidden kb-open:hidden">
			<HoverCard openDelay={100}>
				<HoverCardTrigger asChild>
					<button
						aria-label="Auth debug info"
						className="flex h-8 w-8 md:h-5 md:w-5 items-center justify-center rounded-full bg-muted text-muted-foreground shadow-md transition-colors hover:bg-primary hover:text-primary-foreground"
					>
						<Bug className="h-4 w-4 md:h-3 md:w-3" />
					</button>
				</HoverCardTrigger>
				<HoverCardContent
					side="top"
					align="end"
					className="w-[600px] max-h-[80vh] overflow-auto max-md:max-h-[calc(var(--app-height)-var(--mobile-tabbar-height)-var(--safe-top)-4rem)] max-md:w-[calc(100vw-2rem)]"
				>
					<div className="space-y-2">
						<div className="text-xs text-muted-foreground">
							<span>_user: {auth.user?._id}</span>
							<span className="mx-2">|</span>
							<span>_business: {auth?._id}</span>
						</div>
						<h4 className="text-sm font-semibold">
							Full auth object
						</h4>
						<pre className="rounded bg-muted p-2 text-xs overflow-auto">
							{JSON.stringify(auth, null, 2)}
						</pre>
					</div>
				</HoverCardContent>
			</HoverCard>
		</div>
	);
}
